<template>
    <div class="bh-cursor col-lg-6 col-md-6 col-sm-12 job my-3" @click="goJob">
        <div class="card-job b-white p-4 rounded border">
            <div class="row align-items-center px-2 m-0 px-0">
                <h4 class="fas fa-briefcase b-gray-light p-2 rounded-circle"></h4>
                <div class="ml-2">
                    {{title}} <br>
                    <i class="fas fa-star font-yellow"></i> {{enterprise.name}}
                </div>
            </div> 
            <div class="row">
                <div class="m-3">
                    Tipo de empleo: <span class="font-orange">{{type}}</span> <br>
                    <i class="fas fa-map-marker-alt font-gray-dark"></i> {{location}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        id: Number,
        title: String,
        location: String,
        type: String,
        url_public: String,
        link_enterprise: String,
        enterprise: {},
        data: Object
    },
    
    data(){
        return {

        }
    },
    methods:{
        goJob(){
            this.$router.push('/enterprise/' +this.link_enterprise + '/job/' + this.url_public)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/#public/job/components/home/JobMin.vue